globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Dashboard = appCustomerSpace.Controllers.Dashboard || {};

appCustomerSpace.Controllers.Dashboard.MainController = (function(superClass) {

	utils.extend(MainController, superClass);

	function MainController() {
		return MainController.__super__.constructor.apply(this, arguments);
	}

	$.extend(MainController.prototype, {
		init: function(){
			this.initEvents();

			return MainController.__super__.init.apply(this, arguments);
		},
		initEvents: function(){
			$('#statistics-panel').on('click', '.input-group-btn', function(){
				var $inputGroup = $(this).closest('.input-group');
				var $btn = $(this).find('.btn');

				$inputGroup.find('.input-group-btn').removeClass('active');
				$inputGroup.find('.btn').removeClass('btn-primary');
				$inputGroup.find('.btn').addClass('btn-default');

				$(this).addClass('active');

				$btn.removeClass('btn-default');
				$btn.addClass('btn-primary');
			});

			$('#statistics-panel a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
				$(e.target).closest('.dropdown-menu').find('li').removeClass('active');
				$(e.target).parent('li').addClass('active');
			});
		}
	});

	return MainController;

})(appCustomerSpace.Controllers.MainController);
